export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1733937440188-6c61d7a3759e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxtb3NzJTIwZm9yZXN0JTIwbmF0dXJlfGVufDB8fHx8MTc4ODIzMzM5MXww&ixlib=rb-4.1.0&q=85",
  texture: "https://images.unsplash.com/photo-1652372103950-cadc04ca10ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHw0fHxtb3NzJTIwZm9yZXN0JTIwbmF0dXJlfGVufDB8fHx8MTc4ODIzMzM5MXww&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_HERBS = [
  "Lion's Mane", "Ashwagandha", "Rhodiola", "Ginkgo", "Lemon Balm", "Tulsi",
  "Passionflower", "Skullcap", "Chamomile", "Lavender", "Rose Petal",
  "Raspberry Leaf", "Rosemary", "Burdock Root", "Ginger Root", "Nettle Leaf",
];

export const products = [
  {
    slug: "mental-fatigue-support",
    index: "01",
    name: "Centered Mind Capsules",
    type: "Herbal Capsules",
    tagline: "Clarity, focus and resilience for demanding days.",
    image: "https://images.unsplash.com/photo-1572224703731-2b5431367c9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxsb29zZSUyMGhlcmJhbCUyMHRlYXxlbnwwfHx8fDE3ODgyMzMzOTF8MA&ixlib=rb-4.1.0&q=85",
    intro: "A carefully formulated blend of traditional herbs and functional mushrooms selected to support mental clarity, focus, stress resilience, and everyday cognitive performance. Overall, it aids in mental performance.",
    benefits: [
      { title: "Supports Mental Clarity", text: "Lion's Mane and Ginkgo are commonly used in herbal wellness formulations designed to support clear thinking, concentration, and cognitive function." },
      { title: "Promotes Focus and Attention", text: "Rhodiola and Ginkgo are traditionally associated with maintaining concentration during periods of demanding mental activity." },
      { title: "Supports Resilience to Stress", text: "Ashwagandha and Rhodiola are widely recognized as adaptogenic herbs, traditionally used to help support the body's response to everyday physical and mental stress." },
      { title: "Helps Support Mental Energy", text: "Rhodiola is often used in herbal practice to support stamina and reduce feelings of temporary mental tiredness associated with demanding schedules." },
      { title: "Supports Memory and Cognitive Wellness", text: "Lion's Mane and Ginkgo are frequently incorporated into herb formulations intended to support memory, learning, and long-term cognitive wellness." },
      { title: "Promotes Balanced Energy", text: "Rather than relying solely on stimulant-based ingredients, this formula combines adaptogenic and cognitive-support herbs intended to promote steady, balanced mental performance." },
    ],
    ingredients: [
      { name: "Lion's Mane", text: "Supports cognitive wellness, mental clarity, focus, and healthy nervous-system function." },
      { name: "Ashwagandha", text: "Supports stress resilience, calmness, emotional balance, and overall mental well-being." },
      { name: "Rhodiola", text: "Supports mental stamina, focus, energy, and resilience during periods of temporary fatigue or stress." },
      { name: "Ginkgo", text: "Traditionally used to support memory, concentration, cognitive performance, and healthy circulation." },
    ],
    formulation: "Together, these ingredients create a comprehensive herbal formula designed for individuals seeking natural support for focus, mental stamina, clarity, and resilience during demanding days.",
    compositionLabel: "In Each Bottle",
    composition: [
      { name: "Contents", amount: "90 capsules" },
      { name: "Supply", amount: "30 days at 3 capsules daily" },
      { name: "Approximate Blend Weight", amount: "370 mg per capsule" },
    ],
    table: {
      label: "Blend per Capsule",
      columns: ["Ingredient", "Per Capsule (approx.)", "Per 3 Capsules (approx.)"],
      rows: [
        ["Lion's Mane", "166.5 mg", "499.5 mg"],
        ["Ashwagandha", "92.5 mg", "277.5 mg"],
        ["Rhodiola rosea", "74 mg", "222 mg"],
        ["Ginkgo biloba", "37 mg", "111 mg"],
        ["Total blend", "370 mg", "1,110 mg"],
      ],
    },
    usage: "Take 3 capsules at the start of your day, daily, with water.",
    safety: "Traditional herbal uses and general wellness benefits are described for informational purposes. This product is not intended to diagnose, treat, cure, or prevent disease.",
  },
  {
    slug: "zen-mind-herbal-tea",
    index: "02",
    name: "Serene Sip Tea",
    type: "Herbal Tea Blend",
    tagline: "A calming infusion for rest, balance and stillness.",
    image: "https://images.unsplash.com/photo-1653937855510-ec3fd2036d98?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxsb29zZSUyMGhlcmJhbCUyMHRlYXxlbnwwfHx8fDE3ODgyMzMzOTF8MA&ixlib=rb-4.1.0&q=85",
    intro: "A calming herbal tea formulated with Lemon Balm, Tulsi, Passionflower, and Skullcap to support relaxation, emotional balance, restful sleep, and everyday stress management.",
    benefits: [
      { title: "Promotes Relaxation & Calmness", text: "Lemon Balm, Passionflower, and Skullcap are traditionally used in herbal practice to help promote relaxation and ease occasional nervous tension." },
      { title: "Supports Stress Resilience", text: "Tulsi is widely regarded as an adaptogenic herb and is traditionally used to support the body during periods of everyday physical and mental stress." },
      { title: "Supports Emotional Balance", text: "Lemon Balm and Tulsi are commonly used in calming herbal formulations intended to promote a more balanced, settled state of mind." },
      { title: "Supports Restful Sleep", text: "Passionflower and Skullcap have a long history of traditional use in nighttime herbal preparations designed to encourage relaxation and support restful sleep." },
      { title: "Helps Ease Occasional Mental Tension", text: "The combination of calming herbs is intended to support relaxation during periods of mental overstimulation, restlessness, or demanding schedules." },
      { title: "Supports Mental Clarity", text: "Tulsi and Lemon Balm are commonly included in herbal wellness formulas designed to support clear thinking, particularly when stress and tension are reduced." },
      { title: "Provides Antioxidant Support", text: "Lemon Balm, Tulsi, and Skullcap naturally contain plant compounds with antioxidant properties that contribute to general wellness." },
    ],
    ingredients: [
      { name: "Lemon Balm", text: "A traditional calming herb used to promote relaxation, support a positive mood, ease nervous tension, and support restful sleep." },
      { name: "Tulsi (Holy Basil)", text: "An adaptogenic herb traditionally used to support resilience to stress, emotional balance, mental clarity, and overall well-being." },
      { name: "Passionflower", text: "Traditionally used to promote relaxation, ease occasional nervousness, support restful sleep, and calm an overactive or unsettled mind." },
      { name: "Skullcap", text: "Traditionally used as a nervous-system calming herb to support relaxation, ease occasional tension, and encourage restful sleep." },
    ],
    composition: [
      { name: "Tea Bags per Package", amount: "10" },
      { name: "Herbs per Tea Bag", amount: "3 g" },
      { name: "Total Tea per Package", amount: "30 g" },
    ],
    compositionLabel: "In Each Package",
    brewing: {
      title: "Brewing Ritual",
      steps: [
        "Place 1 tea bag in a cup.",
        "Pour 250 mL (8 oz) of freshly boiled water over the tea bag.",
        "Cover and steep for 7 to 10 minutes to allow the herbs to fully infuse.",
        "Remove the tea bag and enjoy warm.",
      ],
      note: "For a stronger flavour, steep slightly longer rather than using an additional tea bag.",
    },
    formulation: "Zen Mind combines calming herbs with an adaptogenic herb to create a balanced tea designed for periods of stress, mental tension, or evening relaxation. The formula emphasizes gentle herbal support rather than stimulant-based effects, making it suitable as part of a calming wellness routine.",
    safety: "Traditional herbal uses are described for general wellness and educational purposes. This product is not intended to diagnose, treat, cure, or prevent any disease.",
  },
  {
    slug: "smokers-blend-pre-roll",
    index: "03",
    name: "Smoking Blend",
    type: "Herb Pre-Roll",
    tagline: "Mild earth, soft floral, naturally aromatic.",
    image: "https://images.unsplash.com/photo-1596343852472-dccbd388cf0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxsb29zZSUyMGhlcmJhbCUyMHRlYXxlbnwwfHx8fDE3ODgyMzMzOTF8MA&ixlib=rb-4.1.0&q=85",
    intro: "A carefully selected herb blend of Raspberry Leaf, Chamomile, Lavender, and Rose Petal, bringing together mild earthy notes with a soft, naturally floral aroma.",
    ingredients: [
      { name: "Raspberry Leaf", text: "Forms the earthy herb foundation of the blend with a mild, neutral character." },
      { name: "Chamomile", text: "Adds a soft and subtly sweet floral element to the herb profile." },
      { name: "Lavender", text: "Provides a distinctive aromatic quality with naturally fragrant floral notes." },
      { name: "Rose Petal", text: "Completes the blend with a delicate floral aroma and refined herb character." },
    ],
    highlights: [
      "Raspberry Leaf, Chamomile, Lavender & Rose Petal",
      "Tobacco-free",
      "Nicotine-free",
      "Naturally aromatic",
      "Simple four-herb formulation",
    ],
    safety: "Inhaling smoke from any burned plant material can irritate and harm the lungs. Tobacco-free and nicotine-free do not mean risk-free.",
  },
  {
    slug: "yoni-steam",
    index: "04",
    name: "Yoni Steam",
    type: "Herb Steam Blend",
    tagline: "A warm, aromatic ritual of intentional self-care.",
    image: "https://images.unsplash.com/photo-1726921300257-e42a9c4c5dc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxib3RhbmljYWwlMjBoZXJiYWwlMjBhcG90aGVjYXJ5fGVufDB8fHx8MTc4ODIzMzM5MXww&ixlib=rb-4.1.0&q=85",
    intro: "A thoughtfully prepared herb steam blend featuring Raspberry Leaf, Chamomile, Lavender, Rose Petal, and Rosemary. Inspired by traditional herbal self-care practices, this aromatic blend is designed to create a relaxing and intentional wellness ritual.",
    benefits: [
      { title: "Promotes Relaxation", text: "The warmth, aromatic herbs, and quiet ritual of steaming can provide a calming self-care experience." },
      { title: "Supports a Sense of Comfort", text: "Traditionally used as part of personal wellness routines centered around the pelvic area." },
      { title: "Encourages Mindful Self-Care", text: "Creates an opportunity to slow down, relax, and reconnect with the body." },
      { title: "Naturally Aromatic", text: "Lavender, Rose, Chamomile, and Rosemary create a balanced floral and herbaceous herb aroma." },
      { title: "Inspired by Traditional Herbalism", text: "Brings together herbs with long histories of use in herb and wellness preparations." },
    ],
    ingredients: [
      { name: "Raspberry Leaf", text: "A traditional herb that provides a mild, earthy foundation to the blend." },
      { name: "Chamomile", text: "Known for its gentle floral character and long-standing association with relaxation and calming herbal rituals." },
      { name: "Lavender", text: "Provides a distinctive floral aroma commonly associated with relaxation and tranquility." },
      { name: "Rose Petal", text: "Adds a delicate floral quality and is traditionally associated with nurturing and restorative self-care practices." },
      { name: "Rosemary", text: "Contributes a fresh, herbaceous aroma and has a long history of use in traditional herb preparations." },
    ],
    compositionLabel: "Contents per Packet",
    composition: [
      { name: "Raspberry Leaf", amount: "5 g · 25%" },
      { name: "Lavender", amount: "5 g · 25%" },
      { name: "Rosemary", amount: "5 g · 25%" },
      { name: "Rose Petals", amount: "5 g · 25%" },
      { name: "Net Weight", amount: "20 g" },
    ],
    formulation: "Yoni steaming has been practiced in various traditional wellness settings as a warm herbal ritual focused on relaxation, personal care, and connection with the body. This herb formula is designed to complement that experience through its combination of aromatic herbs.",
    care: [
      { title: "Caution", text: "Do not insert into the vagina or apply to genital tissue. Avoid use if sensitive to any ingredient." },
      { title: "Storage", text: "Keep sealed in a cool, dry place, away from moisture and direct sunlight. Keep out of reach of children and pets." },
    ],
    preparation: {
      label: "The Preparation",
      steps: [
        { title: "Equipment", text: "Herbs, freshly boiled water, a heat-safe bowl, seating positioned above it, a breathable covering, and drinking water." },
        { title: "Herbal Preparation", text: "Pour hot water over the herbs to release their aromatic compounds. This gentle infusion differs from simmering tougher plant materials." },
        { title: "Positioning", text: "The container sits below the seated person so the steam rises toward the vulva." },
        { title: "Heat Precautions", text: "Allow the water to cool slightly, check the warmth before beginning, and stop if anything feels uncomfortable. Avoid continuously heated equipment and added essential oils." },
        { title: "Setting", text: "A quiet space, music, meditation, or journaling can form part of the ritual." },
        { title: "Afterward", text: "Discard the herbs and water rather than reusing them." },
      ],
    },
    safety: "Vaginal steaming has not been medically proven to detoxify the uterus, balance hormones or vaginal pH, treat infections, or cure reproductive conditions. Hot steam may cause burns or irritation. For external use only.",
  },
  {
    slug: "gut-support-herbal-tea",
    index: "05",
    name: "Gut Tea",
    type: "Herbal Tea",
    tagline: "Warming, soothing and nourishing, for everyday digestion.",
    image: "https://images.unsplash.com/photo-1726923153036-bbf1e8c113ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxib3RhbmljYWwlMjBoZXJiYWwlMjBhcG90aGVjYXJ5fGVufDB8fHx8MTc4ODIzMzM5MXww&ixlib=rb-4.1.0&q=85",
    intro: "A carefully balanced herbal tea blend of Burdock Root, Ginger Root, Nettle Leaf, and Chamomile, selected for their complementary roles in traditional digestive herbalism.",
    intro2: "This formula is designed to support digestive comfort, normal gastrointestinal function, and overall gut wellness through a combination of warming, soothing, nourishing, and prebiotic-supportive herbs.",
    ingredients: [
      {
        name: "Burdock Root",
        text: "Burdock Root has a long history of use in traditional herbalism as a digestive and general wellness herb. One of its most notable characteristics is its natural content of inulin, a type of prebiotic fibre. Prebiotics are compounds that can serve as food for beneficial bacteria in the digestive tract. Because of this, Burdock Root may help support a healthy intestinal environment and normal gut microbial balance as part of a varied diet.",
        points: [
          "Provides naturally occurring prebiotic fibre",
          "May help nourish beneficial intestinal bacteria",
          "Supports normal digestive function",
          "Traditionally used to support digestion and elimination",
          "Provides antioxidant plant compounds",
          "Commonly included in traditional liver and digestive-support formulas",
        ],
      },
      {
        name: "Ginger Root",
        text: "Ginger is one of the most widely recognized digestive herbs and has been used across many traditional systems of herbal medicine. Its naturally occurring compounds, including gingerols and shogaols, give Ginger its characteristic warming quality and are associated with many of its digestive properties. Its warming nature makes Ginger especially useful in herbal formulas intended to promote comfortable digestion and normal gastrointestinal motility.",
        points: [
          "Supports healthy digestion",
          "Helps support normal gastrointestinal motility",
          "May help ease occasional bloating",
          "May help reduce occasional nausea",
          "Supports digestive comfort after meals",
          "Traditionally used for feelings of digestive heaviness",
          "Contains antioxidant and anti-inflammatory plant compounds",
          "Provides a warming action traditionally associated with digestive support",
        ],
      },
      {
        name: "Nettle Leaf",
        text: "Nettle Leaf is traditionally considered a nourishing herbal tonic rather than a strong digestive herb. Its contribution to a gut-support formula comes from its naturally occurring minerals, vitamins, polyphenols, and other plant compounds. Within this blend, Nettle helps provide a nourishing herb foundation alongside the stronger digestive actions of Ginger, Burdock, and Chamomile.",
        points: [
          "Provides naturally occurring minerals and plant nutrients",
          "Supports general nutritional wellness",
          "Contains antioxidant compounds",
          "Traditionally used as a nourishing herbal tonic",
          "Supports normal fluid balance",
          "Complements digestive herbs with gentle whole-body support",
        ],
      },
      {
        name: "Chamomile",
        text: "Chamomile is one of the most traditional soothing herbs used for digestive comfort. It has historically been used when digestive discomfort is associated with tension, stress, gas, or occasional cramping. Because the digestive and nervous systems are closely connected, Chamomile's relaxing properties make it especially useful in a digestive blend intended to support both physical comfort and a calmer state of mind.",
        points: [
          "Supports digestive comfort",
          "Traditionally used to help ease occasional gas and bloating",
          "May help soothe occasional stomach tension",
          "Supports relaxation during periods of stress",
          "Traditionally used for mild digestive cramping",
          "Contains antioxidant plant compounds",
          "Supports a calm digestive environment",
          "Commonly consumed after meals for gentle digestive support",
        ],
      },
    ],
    composition: [
      { name: "Tea Bags per Package", amount: "10" },
      { name: "Herbs per Tea Bag", amount: "3 g" },
      { name: "Total Tea per Package", amount: "30 g" },
    ],
    compositionLabel: "In Each Package",
    formulation: "Each herb contributes a different aspect of digestive support. Burdock Root provides prebiotic fibre and traditional digestive support. Ginger Root supports digestive movement, warming action, and comfort after meals. Nettle Leaf contributes minerals, antioxidants, and nourishing herb support. Chamomile provides soothing digestive support and helps address the relationship between stress and digestive discomfort. Together, these herbs create a balanced formula designed to support everyday digestion, digestive comfort, and overall gut wellness without relying on harsh or stimulant-based ingredients.",
    brewing: {
      title: "Brewing Ritual",
      steps: [
        "Place one tea bag in your favourite mug.",
        "Pour over 250 mL (8 oz) of freshly boiled water, cover, and steep for 10 to 15 minutes to enjoy the earthy burdock and warming ginger alongside nettle and chamomile.",
        "Remove the tea bag, allow to cool to a comfortable temperature, and add honey or lemon if desired.",
        "Take three slow breaths, relax your shoulders, and set an intention. Sip slowly and give yourself a quiet moment to reconnect.",
      ],
    },
    safety: "Traditional herbal uses are provided for general wellness information only. Individual responses to herbs can vary. This product is not intended to diagnose, treat, cure, or prevent disease.",
  },
  {
    slug: "raspberry-leaf-tea",
    index: "06",
    name: "Moon Bloom Tea",
    type: "Herbal Tea",
    tagline: "A comforting herbal tea for your self-care ritual during your menstrual cycle.",
    image: "",
    intro: "A comforting blend of raspberry leaf, chamomile, and nettle for moments of care during your menstrual cycle. Raspberry leaf is traditionally used to ease mild menstrual cramps, while chamomile may help soothe menstrual discomfort. Earthy nettle completes the blend, inviting you to slow down and reconnect with your body.",
    benefits: [
      { title: "Supports Everyday Nourishment", text: "Nettle Leaf is traditionally valued as a nourishing tonic herb, naturally containing minerals and plant compounds that contribute to general wellness." },
      { title: "Promotes Relaxation", text: "Chamomile is one of the most traditional soothing herbs, long used to promote relaxation and support digestive comfort." },
      { title: "Traditional Women's Wellness", text: "Raspberry Leaf has a long history of use in traditional herbalism, particularly in women's wellness and tonic preparations." },
      { title: "A Gentle Daily Ritual", text: "Mild and naturally caffeine-free, this blend is suited to slow mornings, quiet evenings, and everything in between." },
    ],
    ingredients: [
      { name: "Raspberry Leaf", text: "Traditionally used to ease mild menstrual cramps and helps balance hormones." },
      { name: "Nettle Leaf", text: "A nourishing tonic herb naturally containing minerals such as iron, calcium, and magnesium, traditionally used to support general wellness." },
      { name: "Chamomile", text: "A classic soothing herb traditionally used to promote relaxation, digestive comfort, and restful evenings." },
    ],
    composition: [
      { name: "Tea Bags per Package", amount: "8" },
      { name: "Herbs per Tea Bag", amount: "3 g" },
      { name: "Total Tea per Package", amount: "24 g" },
    ],
    compositionLabel: "In Each Package",
    formulation: "Together, these three herbs create a simple, balanced infusion: earthy Raspberry Leaf, nourishing Nettle, and soothing Chamomile. A quiet cup for everyday wellbeing.",
    brewing: {
      title: "Brewing Ritual",
      steps: [
        "Place one tea bag in your favourite mug.",
        "Pour over 250 mL (8 oz) of freshly boiled water, cover, and steep for 5 to 10 minutes.",
        "Remove the tea bag and add honey or lemon if desired. Allow to cool to a comfortable temperature.",
        "Pause, take three slow breaths, and set an intention for your day. Sip slowly, giving yourself a moment to rest and reconnect.",
      ],
    },
    safety: "Traditional herbal uses are described for general wellness and educational purposes only. This product is not intended to diagnose, treat, cure, or prevent any disease. If you are pregnant or nursing, consult a qualified healthcare practitioner before use.",
  },
];
